import { render, staticRenderFns } from "./demo-requests.vue?vue&type=template&id=14cd8e35&"
import script from "./demo-requests.vue?vue&type=script&lang=js&"
export * from "./demo-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports